import React from 'react';
import TextFieldComp from '../TextFieldComp';
import GridCenterItem from '../GridCenterItem';
import CustomPhoneInput from '../customPhoneInput';
import { InputAdornment, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TermsContainer from '../loginPage/TermsContainer';
import AgeRes from './AgeRes';
import { signUpTermsText } from '../../constants';

function SignupSkeleton({
  fError,
  fHelp,
  fValue,
  changeFName,
  handleEnter,
  inputStyles,
  LError,
  LHelp,
  LValue,
  changeLName,
  EError,
  EHelp,
  EValue,
  changeEmail,
  mailBlurHandle,
  PwError,
  PwHelp,
  PwValue,
  changePassword,
  showPassword,
  handleClickShowPassword,
  handleMouseDownPassword,
  PError,
  PHelp,
  PValue,
  changePhone,
  disabled,
  fromProfPage,
  phoneErrorCls,
  isUserPage,
  termsContainer,
  policyLink,
  termsText,
  checkBoxStyles,
  CError,
  CHelp,
  CValue,
  changeConfPass,
  AgeError,
  AgeHelp,
  AgeValue,
  changeAge,
  TermsError,
  TermsHelp,
  TermsValue,
  changeTerms,
  showPhoneInput,
}) {
  return (
    <>
      <GridCenterItem>
        <TextFieldComp
          disabled={disabled ? true : false}
          name="FirstName"
          label="First Name *"
          placeholder="First Name"
          error={fError}
          helpertext={fHelp}
          value={fValue}
          onChange={changeFName}
          handleEnter={handleEnter}
          inputStyles={inputStyles}
        />
      </GridCenterItem>
      <GridCenterItem>
        <TextFieldComp
          disabled={disabled ? true : false}
          name="LastName"
          label="Last Name *"
          placeholder="Last Name"
          error={LError}
          helpertext={LHelp}
          value={LValue}
          onChange={changeLName}
          handleEnter={handleEnter}
          inputStyles={inputStyles}
        />
      </GridCenterItem>
      <GridCenterItem>
        <TextFieldComp
          disabled={fromProfPage ? true : false}
          name="EmailAddress"
          label="Email Address *"
          placeholder="Email Address"
          error={EError}
          helpertext={EHelp}
          value={EValue}
          onChange={changeEmail ? changeEmail : () => null}
          handleEnter={handleEnter}
          inputStyles={inputStyles}
          blurHandle={mailBlurHandle ? mailBlurHandle : () => null}
        />
      </GridCenterItem>
      {isUserPage ? (
        <>
          <GridCenterItem>
            <TextFieldComp
              // variant="outlined"
              disabled={disabled ? true : false}
              name="Password"
              label="Password *"
              placeholder="Password"
              // min= {8}
              error={PwError}
              helpertext={PwHelp}
              value={PwValue}
              onChange={changePassword}
              handleEnter={handleEnter}
              inputStyles={inputStyles}
              type={showPassword ? 'text' : 'password'} // <-- This is where the magic happens
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </GridCenterItem>
          <GridCenterItem>
            <TextFieldComp
              name="ConfirmPassword"
              label="Confirm Password *"
              placeholder="Confirm Password"
              error={CError}
              helpertext={CHelp}
              value={CValue}
              onChange={changeConfPass ? changeConfPass : () => null}
              handleEnter={handleEnter}
              inputStyles={inputStyles}
              type="password"

              // }}
            />
          </GridCenterItem>
        </>
      ) : null}
      {showPhoneInput ? (
        <GridCenterItem>
          <div className={inputStyles}>
            <CustomPhoneInput
              disabled={disabled ? true : false}
              label="Phone Number *"
              placeholder="Phone Number"
              error={PError}
              helpertext={PHelp}
              value={PValue}
              onChange={changePhone}
              handleEnter={handleEnter}
              phoneErrorCls={phoneErrorCls}
            />
          </div>
        </GridCenterItem>
      ) : null}
      {isUserPage ? (
        <>
          <GridCenterItem>
            <div
              className={checkBoxStyles}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Checkbox
                color="primary"
                value={AgeValue}
                onChange={changeAge}
                handleEnter={handleEnter}
                id="age"
              />
              <label
                style={{ color: AgeError ? 'red' : 'inherit' }}
                // htmlFor="age"
              >
                <AgeRes />
              </label>
            </div>
          </GridCenterItem>
          <GridCenterItem>
            <div
              className={checkBoxStyles}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Checkbox
                color="primary"
                required
                value={TermsValue}
                onChange={changeTerms}
                handleEnter={handleEnter}
                inputProps={{ 'aria-label': 'primary checkbox' }}
                id="terms"
              />
              <label
                style={{ color: TermsError ? 'red' : 'inherit' }}
                // className={checkBoxStyles}
                // htmlFor="terms"
              >
                <TermsContainer
                  termsContainer={termsContainer}
                  policyLink={policyLink}
                  termsText={termsText}
                  helpingText={signUpTermsText}
                />
              </label>
            </div>
          </GridCenterItem>
        </>
      ) : null}
    </>
  );
}

export default SignupSkeleton;
